var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3254_8526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9951 20.5008V20.5H20.0001V13.165C20.0001 9.57667 19.2276 6.8125 15.0326 6.8125C13.0159 6.8125 11.6626 7.91917 11.1101 8.96833H11.0517V7.1475H7.07422V20.5H11.2159V13.8883C11.2159 12.1475 11.5459 10.4642 13.7017 10.4642C15.8259 10.4642 15.8576 12.4508 15.8576 14V20.5008H19.9951Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 7.14844H4.4787V20.5009H0.332031V7.14844Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.40167 0.5C1.07583 0.5 0 1.57583 0 2.90167C0 4.2275 1.07583 5.32583 2.40167 5.32583C3.7275 5.32583 4.80333 4.2275 4.80333 2.90167C4.8025 1.57583 3.72667 0.5 2.40167 0.5V0.5Z",
    fill: "#4B4B4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3254_8526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b4da2b29bd921ca39cf13d5df06751ca.svg";
export { ForwardRef as ReactComponent };